import { ChallengeDrawerBody } from './ChallengeDrawerBody';
import { ChallengeDrawerHeader } from './ChallengeDrawerHeader';
import { ChallengesDrawerOverflowCard } from './ChallengesDrawerOverflowCard';
import { ChallengesDrawer } from './index';

export const challengesDrawerConfiguration = {
  drawer: ChallengesDrawer,
  body: ChallengeDrawerBody,
  header: ChallengeDrawerHeader,
  overflowCard: ChallengesDrawerOverflowCard,
  allowMultipleInstance: true,
};
